//This file is automatically rebuilt by the Cesium build process.
export default "void metadataStage(out Metadata metadata, ProcessedAttributes attributes)\n\
{\n\
initializeMetadata(metadata, attributes);\n\
setMetadataVaryings();\n\
}\n\
";
